import { Organization } from './organization.model';
import { UserType } from './user-type.model';

export const ORGANIZATION_MANAGER_ID = '5';
export class OrganizationAsUserProperty extends Organization {
    public roles: UserType[];
}
